export class IdentityProviderController {
    private usernameStorageKey: string = "idSrvUsername";
    private rememberMe: boolean = false;

    private get $rememberMeCheckbox() {
        return $("#RememberLogin");
    }

    private get $usernameInput() {
        return $("#Username");
    }

    private get $passwordInput() {
        return $("#Password");
    }

    private get $redirectUrl(): string {
        return <string>$("#RedirectUrl").val();
    }

    private get $returnUrl():string {
        return <string>$("#ReturnUrl").val();
    }

    private get $nonceTimeoutSeconds():number {
        return <number>$("#NonceTimeoutSeconds").val();
    }

    private get $loginButton() {
        return $("#LogInBtn");
    }

    private get $form() {
        return $("form");
    }

    constructor(public localStorage: Storage) {
        var self = this;

        $(document).ready(function () {
            $('[data-toggle="popover"]').popover();

            window.addEventListener("load", () => {
                var a = document.querySelector("a.PostLogoutRedirectUri");
                if (a) {
                    window.location.assign((<any>a).href);
                }
            });

            if (self.$nonceTimeoutSeconds > 0 && self.$redirectUrl.length > 0) {
                window.setTimeout(() => {
                    window.location.href = self.$redirectUrl;
                }, self.$nonceTimeoutSeconds * 1000);
            }

            self.initRememberMe();
            self.initLoginButtonClick();
        });
    }

    private initRememberMe = () => {
        this.$rememberMeCheckbox.on("change", (e: JQueryEventObject) => {
            this.rememberMeChanged($(e.currentTarget).is(":checked"));
        });

        var storedValue = this.getUsernameFromStorage();

        if (!!storedValue) {
            this.$usernameInput.val(storedValue);
            this.$rememberMeCheckbox.prop("checked", true);
            this.rememberMeChanged(true);
            this.$passwordInput.focus();
        }
    }

    private initLoginButtonClick = () => {
        this.$loginButton.on("click", (e: JQueryEventObject) => {
            this.$loginButton.prop("disabled", "disabled");
            this.$form.submit();
            e.preventDefault();
        });
    }

    private rememberMeChanged = (isChecked: boolean) => {
        this.rememberMe = isChecked;
        if (!!isChecked) {
            this.usernameChanged(null);
            this.$usernameInput.on("keyup change", this.usernameChanged);
        }
        else {
            this.usernameChanged(null);
            this.$usernameInput.off("keyup change");
        }
    }

    private usernameChanged = (event: JQueryEventObject | null) => {
        //Don't do anything if username isn't visible.
        if (!!this.$usernameInput.length) {
            if (!!this.rememberMe) {
                this.setUsernameInStorage(<string>this.$usernameInput.val());
            }
            else {
                this.removeUsernameFromStorage();
            }
        }
    }

    private removeUsernameFromStorage = () => {
        delete this.localStorage[this.usernameStorageKey];
    }

    private setUsernameInStorage = (username: string) => {
        //console.log(username);
        this.localStorage[this.usernameStorageKey] = username;
    }

    private getUsernameFromStorage = () => {
        return this.localStorage[this.usernameStorageKey];
    }
}